export default __webpack_public_path__ + "static/media/Pellar_A01.bc3463f1.mp4";